module.exports = __webpack_public_path__ + "static/route1-e43fa70c359c6a8be7f69a358a532053.jpg";